<template>
  <Transition name="loading-fade">
    <div 
      v-if="isVisible" 
      class="loading-ui" 
      role="alert" 
      aria-busy="true" 
      aria-label="화면 로딩 중입니다"
    >
      <div class="loading-item" aria-hidden="true">IC</div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const isVisible = ref(false)

// 마운트되자마자 애니메이션 시작 (기존의 requestAnimationFrame 역할)
onMounted(() => {
  isVisible.value = true
})

// 외부(useLoading)에서 닫기 애니메이션을 트리거하기 위해 노출
const hide = () => {
  isVisible.value = false
}

defineExpose({ hide })
</script>